import { format } from 'date-fns';

const LICENSE_SEGMENT_COUNT = 4;
const LICENSE_SEGMENT_LENGTH = 4;
const KEY_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

export const generateLicenseKey = (prefix: string): string => {
  const normalizedPrefix = prefix.toUpperCase().slice(0, 3);
  const segments: string[] = [];

  for (let segmentIndex = 0; segmentIndex < LICENSE_SEGMENT_COUNT; segmentIndex += 1) {
    let segment = normalizedPrefix;

    while (segment.length < LICENSE_SEGMENT_LENGTH) {
      const randomIndex = Math.floor(Math.random() * KEY_CHARSET.length);
      segment += KEY_CHARSET.charAt(randomIndex);
    }

    segments.push(segment);
  }

  return segments.join('-');
};

export const formatApiDateTime = (value: string | null | undefined, fallback: string): string => {
  if (!value) {
    return fallback;
  }

  try {
    const normalized = value.includes(' ') ? value.replace(' ', 'T') : value;
    const date = new Date(normalized);
    if (Number.isNaN(date.getTime())) {
      return fallback;
    }
    return format(date, 'yyyy-MM-dd HH:mm:ss');
  } catch {
    return fallback;
  }
};

export const toDateInputValue = (value: string | null | undefined): string => {
  if (!value) {
    return '';
  }
  return value.split('T')[0] ?? '';
};

export const isDateExpired = (value: string | null | undefined): boolean => {
  if (!value) {
    return false;
  }
  const normalized = value.includes(' ') ? value.replace(' ', 'T') : value;
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) {
    return false;
  }
  return date.getTime() < Date.now();
};

export const toExpiryDateByDays = (days: number | null): string => {
  if (!days || days <= 0) {
    return '';
  }

  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + days);
  return expiryDate.toISOString().split('T')[0] ?? '';
};

